import { createContext } from 'react'

import { createCrudModalFormStore } from '../store/createStore'

export const CrudModalFormStoreContext = createContext<
  ReturnType<typeof createCrudModalFormStore> | undefined
>(undefined)
